import {cva} from 'class-variance-authority'

/**
 * Layout + spacing for a `DataRow`.
 *
 * - `pt-2` (8px) top padding always; bottom padding is `pb-3` (12px) when a
 *   divider is shown, else `pb-2` (8px) — matching the Figma "Data Row" frame.
 * - `horizontal` puts the label and value on one line (`justify-between`);
 *   `stacked` puts the value beneath the label (`flex-col`).
 */
export const DataRowVariantsFactory = cva('flex w-full pt-2', {
  variants: {
    orientation: {
      horizontal: 'items-center justify-between',
      stacked: 'flex-col items-start',
    },
    divider: {
      true: 'border-b border-divider pb-3',
      false: 'pb-2',
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
    divider: true,
  },
})
